import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ContactStatus } from '../../../../../sic-lib/types/ContactStatus';

const useStyles = makeStyles()((theme: Theme) => ({
    item: {
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
            '&:hover': {
                backgroundColor: theme.palette.menuListHover.main,
            },
        },
    },
}));

interface Props {
    menuId: string;
    anchorEl: HTMLElement | null;
    contactId: number;
    statusId: number | null;
    statusList: ContactStatus[];
    onChangeHandler: (event: React.MouseEvent<HTMLElement>) => void;
    onCloseHandler: () => void;
}

export default function MenuSetContactStatusRaw({
    menuId,
    anchorEl,
    statusId,
    statusList,
    onChangeHandler,
    onCloseHandler,
}: Props) {
    const { classes } = useStyles();

    return (
        <Menu id={menuId} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onCloseHandler}>
            {statusList.map(itm => (
                <MenuItem
                    key={itm.statusId}
                    data-status-id={itm.statusId}
                    selected={itm.statusId === statusId}
                    onClick={onChangeHandler}
                    className={classes.item}
                >
                    {itm.status}
                </MenuItem>
            ))}
        </Menu>
    );
}
